import {useEffect} from 'react';
import {ToastMessageVariants} from '../../../../../../../util/uiconstants';
import {labels} from '../../../../../../../util/utils';
import Utility from '../../../../../../../util/utilityfunctions';
import {setFormV2ToasterVisibility} from '../../../../../../../actions/toastactions';
import {useDispatch} from 'react-redux';

export default function IndependenceTemplateBanner(props) {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(
			setFormV2ToasterVisibility(
				true,
				ToastMessageVariants.Warning,
				Utility.createRichTextElement(labels.independenceViewTemplateMessage)
			)
		);
	}, [dispatch]);
}
